import { type ChangelogRelease } from '@webapp/platform/discover-more/entities/ChangelogRelease'

export interface GetNewestChangelogReleasesParams {
  releases: ChangelogRelease[]
  limit: number
}

/**
 * Picks the newest releases with a hero image, newest first. Releases without a
 * hero image are dropped and backfilled by the next newest one.
 */
export const getNewestChangelogReleases = ({
  releases,
  limit,
}: GetNewestChangelogReleasesParams): ChangelogRelease[] =>
  releases
    .filter((release) => release.hasHeroImage)
    .sort((a, b) => b.publishedAtTimestamp - a.publishedAtTimestamp)
    .slice(0, limit)
